<template>
  <div>
    <!--ul class="munes mt15">
      <li class="munes_cell">
         <router-link to="/goodsNav/hot">
            <img src="../../images/99.png" class="munes_cell_img" />
            <span>热销榜</span>
         </router-link>
      </li>
      <!--li class="munes_cell">
         <router-link to="/goodsNav/editor">
            <img src="../../images/ht.png" class="munes_cell_img" />
            <span>小编精选</span>
         </router-link>
      </li-->
      <!--li class="munes_cell">
         <router-link to="/goodsNav/jhs">
            <img src="../../images/jhs.png" class="munes_cell_img" />
            <span>聚划算</span>
         </router-link>
      </li>
      <li class="munes_cell">
         <router-link to="/goodsNav/brand">
            <img src="../../images/ppq.png" class="munes_cell_img" />
            <span>品牌券</span>
         </router-link>
      </li>
      <li class="munes_cell">
         <router-link to="/goodsNav/grapBuying">
            <img src="../../images/tqg.png" class="munes_cell_img" />
            <span>淘抢购</span>
         </router-link>
      </li>
    </ul-->
  </div>

</template>
<script type = "text/ecamscript-6">
/* eslint-disable */
  export default {
    name:"mune"
  }
</script>
<style lang="stylus">
  .munes
    width:100%
    padding:20px 0
    display:flex
    background:#fff
    .munes_cell
      flex:1
      text-align:center
      font-size:24px
      color:#666
      .munes_cell_img
        width:92px
        height:92px
        display:block
        margin:0 auto 5px

</style>



// WEBPACK FOOTER //
// src/components/goodsCoupon/mune.vue